import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Icons
// Data
import {
  babyGalleryAdditionalMeta,
  babyGalleryStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import BabyGalleryMainContainer from '../../components/galleries/BabyGalleryMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AltHeader from '../../components/general/AltHeader';
import HeaderBanner from '../../components/general/HeaderBanner';
// Images
import BgImage from '../../assets/images/backgrounds/playful-background-images.webp';

function BabyGallery() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Adult Baby Gallery'
        desc={`Enter the playful and humiliating world of ${CompanyName}'s Adult Baby sessions. This gallery reveals the soft, silly, and strictly controlled life of sissies and diaper nappy diaperer lovers under the command of Mistress Maria.`}
        keywords={`Mistress Maria, Adult Baby, ABDL, nappy Diaper Discipline, Sissy Baby, Humiliation, Adult Baby Domination, Femdom ABDL, Sissy Regression`}
        additionalMeta={babyGalleryAdditionalMeta}
        structuredData={babyGalleryStructuredData}
      />

      {/* Page */}
      <div
        className='grid min-h-screen overflow-hidden text-colour2 dark:text-colour1 font-poppins invisible_scrollbar'
        style={{
          backgroundImage: `url(${BgImage})`,
          backgroundRepeat: 'repeat-y',
          backgroundSize: '100% auto',
          backgroundPosition: 'top center',
        }}
      >
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={'ABDL Gallery'} />
          </header>
        </div>

        {/* Main page content */}
        <BabyGalleryMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default BabyGallery;
